<template>
    <div class="card">
        <div class="table-header mb-3">
            <h5 class="p-m-0">
                Ключові характеристики для підбору аналогів
            </h5>
            <div class="action_panel">
                <a href="javascript:void(0)" style="color: #ffff;" class="btn btn-warning" @click="xmlGenerate()">
                    <span v-if="xmlGenerateloading">Індексація...</span>
                    <span v-else>Проіндексувати</span>
                </a>
                <Button @click="getExcel()" icon="pi pi-external-link" label="Викачаті основні характеристики" />
                <a href="/api/analogs/variants" target="_blank">
                    <Button label="Індекси товарів" icon="pi pi-external-link" />
                </a>
            </div>
        </div>
        <div class="row">
            <div class="col-md-5">
                <InputText class="search_input mb-2" placeholder="Пошук за назвою" v-on:keyup="getCatalogTree()" v-model="searchCategoryName" />
                <div class="modal_main_content_container">
                    <p v-if="categoriesLoading">Завантаження..</p>
                    <Tree v-else v-model:selectionKeys="selectedCategories" :value="categories" @nodeSelect="getData" @nodeUnselect="getData" selectionMode="checkbox" class="catalog_tree"></Tree>
                </div>
            </div>
            <div class="col-md-7">
                <div class="card">
                    <div class="card-body d-flex flex-column">
                        <p>Оберіть категорію</p>
                        <DataTable
                            :value="data"
                            v-model:filters="filterParams.filters"
                            filterDisplay="row"
                            paginator
                            lazy
                            :rows="filterParams.perPage"
                            :rowsPerPageOptions="[10, 50, 100, 200]"
                            :total-records="total"
                            :loading="loading"
                            @page="onPage($event)"
                            @filter="getData()"
                            class="customTable"
                            style="overflow: auto;"
                            paginator-template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            current-page-report-template="Всього {totalRecords}"
                            :rowClass="rowClass"
                        >
                            <Column field="name" header="Найменування" headerStyle="min-width: 100px">
                                <template #body="slotProps">
                                    {{ slotProps.data.name }}
                                </template>
                                <template #filter>
                                    <InputText v-model="filterParams.filters.name.value" type="text" @input="getData()" placeholder="Пошук" />
                                </template>
                            </Column>
                            <Column field="unit" header="Од. виміру">
                                <template #body="slotProps">
                                    {{ slotProps.data.unit }}
                                </template>
                                <template #filter>
                                    <InputText v-model="filterParams.filters.unit.value" type="text" @input="getData()" placeholder="Пошук" />
                                </template>
                            </Column>
                            <Column field="group" header="Група" headerStyle="min-width: 150px">
                                <template #body="slotProps">
                                    {{ slotProps.data.group }}
                                </template>
                                <template #filter>
                                    <InputText v-model="filterParams.filters.group.value" type="text" @input="getData()" placeholder="Пошук" />
                                </template>
                            </Column>
                            <Column field="is_active" header="" headerStyle="min-width: 20px;">
                                <template #body="slotProps">
                                    <input type='checkbox' v-model="slotProps.data.analogs_categories_exists" style="transform: scale(1.4);"/>
                                </template>
                            </Column>
                        </DataTable>

                        <div class="bottom_btns">
                            <a href="javascript:void(0)" class="add_file_btn" @click="save()">Зберегти</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import AppLayout from "@/Layouts/AppLayout";
import DataTable from "primevue/datatable";
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import swal from 'sweetalert2';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import Toast from 'primevue/toast';
import {FilterMatchMode} from "primevue/api";
import Tree from 'primevue/tree';
import "bootstrap/dist/css/bootstrap.min.css";

export default {

    components: {
        DataTable,
        Column,
        InputText,
        swal,
        Dialog,
        Button,
        Dropdown,
        Toast,
        Tree,
    },
    layout: AppLayout,

    data() {
        return {
            data: [],
            searchCategoryName: null,
            total: 0,
            filterParams: {
                page: 1,
                perPage: 10,
                selectedCategories: {},
                filters: {
                    name: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    unit: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    type: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    group: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    is_active: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    is_filter: { value: null, matchMode: FilterMatchMode.CONTAINS },
                }
            },
            loading: false,
            xmlGenerateloading: false,
            categoriesLoading: false,
            selectAll: false,
            viewVariants: [
                {
                    value: null,
                    name: 'Всі'
                },
                {
                    value: true,
                    name: 'Активні'
                },
                {
                    value: false,
                    name: 'Приховані'
                },
            ],
            isSelectCategory: false,
            categories: [],
            selectedCategories: {},
            selectedItem: null,
        }
    },

    mounted() {
        this.getCatalogTree();
    },

    computed: {
        selectedCategoriesCount() {
            let total = 0

            Object.values(this.selectedCategories).forEach((value, index) => {
                if (value.checked) {
                    total++
                }
            });
            
            return total
        }
    },

    methods: {
        getCatalogTree() {
            this.categoriesLoading = true
            axios.get(this.route('analogs.catalog_tree'), {params: {name: this.searchCategoryName}})
                .then((result) => {
                    this.categoriesLoading = false
                    this.categories = result.data.categories
                    this.xmlGenerateloading = result.data.payload
                }).catch((error) => {
                    this.categoriesLoading = false
                    alert(error)
                    console.log(error)
                    window.scroll(0, 0);
                })
        },
        updateCategories() {
            axios.post(this.route('api.analogs.characteristic.category.update'), {id: this.selectedItem, categories: this.selectedCategories}).then(result => {
                this.$toast.add({ severity: 'success', summary: 'Успішно збережено!', detail: 'Характеристики успішно оновлено', life: 3000 });
                this.selectedCategories = {};
                this.selectedItem = null;
                this.isSelectCategory = false
                this.getData()
            });
        },
        xmlGenerate() {
            if (!this.xmlGenerateloading) {
                this.xmlGenerateloading = true
                axios.post(this.route('api.analogs.characteristic.xml')).then(result => {
                    this.$toast.add({ severity: 'success', summary: 'Процес індексації розпочався', detail: '', life: 3000 });
                });
            }
        },
        getData() {
            this.loading = true
            this.filterParams.selectedCategories = _.cloneDeep(this.selectedCategories)
            axios.post(this.route('api.analogs.characteristic.get'), this.filterParams).then(result => {
                this.data = result.data.characteristics.data;
                this.total = result.data.characteristics.total;
                this.loading = false
            });
        },
        onPage(event) {
            this.filterParams.page = event.page+1
            this.filterParams.perPage = event.rows
            this.getData()
        },
        rowClass (data) {
            return data.analogs_categories_exists ? 'highlighted-row' : '';
        },
        save() {
            axios.post(this.route('api.analogs.characteristic.category.update'), {data: this.data, categories: this.selectedCategories})
                .then((result) => {
                    this.$toast.add({ severity: 'success', summary: 'Успішно збережено!', detail: 'Характеристики успішно оновлено', life: 3000 });
                    this.getData()
                    // this.getCatalogTree()
                }).catch((error) => {
                    alert(error)
                    console.log(error)
                    window.scroll(0, 0);
                })
        },

        getExcel() {
            axios.post(this.route('api.analogs.characteristic.category.get_excel'))
            .then((response) => {
                var fileURL = response.data.data;
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', response.data.name);
                document.body.appendChild(fileLink);
                fileLink.click();
            }).catch((error) => {
                console.log(error);
                window.scroll(0, 0);
            })
        }
    }
};
</script>

<style scoped>
.bottom_btns {
    display: flex;
    gap: 16px;
    padding-top: 50px;
}
.add_file_btn {
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    border-radius: 4px;
    background: #356EEF;
    display: flex;
    width: 237px;
    height: 40px;
    padding: 8px 16px;
    justify-content: center;
    align-items: center;
    text-decoration: none!important;
}
.add_file_btn.disabled {
    cursor:not-allowed;
    filter: opacity(0.5);
}
.add_file_btn.main {
    background-color: #FFFFFF;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    color: #000000;
    box-shadow: 0px 1px 2px 0px #0000004D;
}
.confirm_buttons {
    display: flex;
    gap: 20px;
}
.confirm_button_cancel {
    display: flex;
    padding: 12px 30px;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: #356EEF;
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
}
.confirm_button_confirm {
    display: flex;
    padding: 12px 30px;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: #FFF;
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.30);
}
.price_input {
    height: 40px!important;
    width: 100%;
    align-items: center;
    display: flex;
}
.check-text input {
  display: none;
}
.check-text svg {
  cursor: pointer;
}
.modal_main_content_container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-height: 685px;
    overflow: auto;
}
.p-inputtext {
    height: auto;
}
.p-dropdown-label .p-inputtext{
    align-items: center;
    display: flex;
}
.selected_cats {
    margin-bottom: 20px;
}
.selected_cats p {
    margin: 0px;
}
.search_input {
    width: 100%;
}
.table-header {
    display: flex;
    justify-content: space-between;
}
.action_panel {
    display: flex;
    gap: 15px;
}
</style>
